
import { Component, Vue, Prop } from 'vue-property-decorator'
import { getAntSmsLog } from '@/api/product/smsAccount'
import { jsonToObjArr, parseTime } from '@/utils'

@Component({
  name: 'version',
  components: {},
  filters: {
    parseTime(date) {
      return parseTime(date, '{y}-{m}-{d} {h}:{i}:{s}')
    }
  }
})
export default class extends Vue {
  private listLoading = false
  private list: any[] = []
  private total = 0

  private queryForm: any = {
    ant_account: '',
    phone: '',
    status: ''
  }

  private select () {
    this.hadleGetFilesListApi()
  }

  private reset () {
    this.queryForm = {
      ant_account: '',
      phone: '',
      status: ''
    }
    this.hadleGetFilesListApi()
  }

  // 分页器设置
  private pagesize: number = 20
  private handleSizeChange (size) {
    this.pagesize = size
    this.hadleGetFilesListApi()
  }

  // 分页切换
  private currentPage: number = 1
  private handleCurrentChange (currentPage) {
    this.currentPage = currentPage
    this.hadleGetFilesListApi()
  }

  // 对所有数据进行分页处理 发送请求
  private async hadleGetFilesListApi () {
    try {
      this.listLoading = true
      // axios
      //   .get(this.url, {
      const params = {
        ...this.queryForm,
        page_size: this.pagesize,
        page: this.currentPage
      }
      //   })
      //   .then((res: any) => {
      //     this.total = res.data.count
      //     this.list = res.data.results
      //     this.listLoading = false
      //   })
      //   .catch(() => {
      //     this.list = []
      //     this.listLoading = false
      //   })
      await getAntSmsLog(params).then((res: any) => {
        this.list = res.results
        this.total = res.count
        this.listLoading = false
      })
    } catch (e) {
      this.listLoading = false
    }
  }

  private jump (row: any) {
    window.open(row)
  }

  private devBotTokenVis: boolean = false
  private upstreamData: any = {}
  private request: any[] = []
  private reponse: any[] = []
  private openLog(row) {
    this.upstreamData = row.extra_param.sms_request
    if (row.extra_param.sms_request) {
      this.request = jsonToObjArr(this.upstreamData.request)
    }
    if (row.extra_param.sms_request) {
      this.reponse = jsonToObjArr(this.upstreamData.reponse)
    }
    this.devBotTokenVis = true
  }
  private closeDevBotToken() {
    this.devBotTokenVis = false
  }

  mounted () {
    this.hadleGetFilesListApi()
  }
}
